import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Swallow the benign "ResizeObserver loop" warning that CRA's dev overlay
// surfaces as a full-screen red error. It is emitted by Radix (Dialog/Select)
// during layout flushes and is harmless.
const RO_MSG = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(RO_MSG)) {
    e.stopImmediatePropagation();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason && String(e.reason).includes(RO_MSG)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
